import { cloneDeep } from "lodash";
import { EXCHANGE_ACTIVE_STATUS } from "../../modules/exchanges/constants/exchange.consts";
import { Order } from "./order";

const DEFAULT_ATTRIBUTES = {
  created_at: null,
  events: null,
  id: null,
  order_exchange: null,
  order_send: null,
  seller_id: null,
  status: EXCHANGE_ACTIVE_STATUS,
  type: "regular",
};

export class OrderChange {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      if (key === "order_exchange" || key === "order_send") {
        this[key] = new Order(attrs[key]);
      } else {
        this[key] = attrs[key];
      }
    });
  }

  get isExchangeAndReturn() {
    return this.type === "exchange_and_return";
  }

  get isSynchronized() {
    return this.type === "synchronized";
  }

  get isUnsynchronized() {
    return this.type === "unsynchronized";
  }

  canBe(action, loggedInUser) {
    if (this.abilities.hasOwnProperty(action)) {
      return this.abilities[action](loggedInUser);
    }

    return true;
  }

  abilities = {
    archived: () => !this.archived,
    unarchived: () => this.archived,
    resumed: () =>
      (this.isSynchronized || this.isExchangeAndReturn) &&
      this.order_send.canBe("resumed"),
    paused: (loggedInUser) => this.order_send.canBe("paused", loggedInUser),
    cancelled: (loggedInUser) =>
      this.order_send.canBe("cancelled", loggedInUser),
  };
}
